/* tslint:disable */
/* eslint-disable */
/**
 * cellera-backend API spec
 * Backend Service for Cellera | [swagger.json](cellera/swagger.json)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  ErrorResponse,
  TriggerUserMigrationDto,
} from '../models/index';
import {
    ErrorResponseFromJSON,
    ErrorResponseToJSON,
    TriggerUserMigrationDtoFromJSON,
    TriggerUserMigrationDtoToJSON,
} from '../models/index';

export interface TriggerUserMigrationRequest {
    triggerUserMigrationDto: TriggerUserMigrationDto;
}

/**
 * 
 */
export class AdminMigrationApi extends runtime.BaseAPI {

    /**
     * Trigger Firebase user migration to tenants
     */
    async triggerUserMigrationRaw(requestParameters: TriggerUserMigrationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['triggerUserMigrationDto'] == null) {
            throw new runtime.RequiredError(
                'triggerUserMigrationDto',
                'Required parameter "triggerUserMigrationDto" was null or undefined when calling triggerUserMigration().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["X-API-Key"] = await this.configuration.apiKey("X-API-Key"); // api-key authentication
        }

        const response = await this.request({
            path: `/admin/migrate-users-to-tenants`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: TriggerUserMigrationDtoToJSON(requestParameters['triggerUserMigrationDto']),
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Trigger Firebase user migration to tenants
     */
    async triggerUserMigration(requestParameters: TriggerUserMigrationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.triggerUserMigrationRaw(requestParameters, initOverrides);
    }

}
